/* LUNEXUS Warm – Header, Menü-Drawer, Suche mit Vorschlägen, Ankündigung.
   Ohne Abhängigkeiten; läuft deferred. Warenkorb-Zähler/Drawer: Horizon (<cart-icon>, #cart-drawer). */
(function () {
  'use strict';
  var doc = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desk = window.matchMedia('(min-width: 900px)');
  var group = doc.getElementById('header-group');
  var header = doc.getElementById('lx-header');
  if (!header) return;

  /* ── Höhen: Ankündigung (scrollt weg) + sichtbarer Header für Sticky-Elemente ── */
  var ann = group && group.querySelector('.lx-ann');
  var hidden = false;
  function measure() {
    var annH = ann ? ann.offsetHeight : 0;
    if (group) group.style.setProperty('--lx-ann-h', annH + 'px');
    doc.body.style.setProperty('--header-height', (hidden ? 0 : header.offsetHeight) + 'px');
    doc.body.style.setProperty('--header-group-height', (group ? group.offsetHeight : header.offsetHeight) + 'px');
  }
  measure();
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  window.addEventListener('load', measure);

  /* ── Header beim Runterscrollen ausblenden, beim Hochscrollen zeigen ──
     Desktop (>=990px) scrollt in Horizon .page-wrapper, mobil das Dokument. */
  var wrapper = doc.querySelector('.page-wrapper');
  var lastY = 0, ticking = false;
  function scrollY() {
    var w = wrapper && wrapper.scrollHeight > wrapper.clientHeight && getComputedStyle(wrapper).overflowY !== 'visible' ? wrapper.scrollTop : 0;
    return Math.max(w, window.scrollY || doc.documentElement.scrollTop || 0);
  }
  function busy() {
    return doc.documentElement.classList.contains('lx-lock') ||
      header.contains(doc.activeElement) ||
      !!header.querySelector('.lx-nav__item.is-open');
  }
  function setHidden(h) {
    if (h === hidden || !group) return;
    hidden = h;
    group.classList.toggle('lx-hidden', h);
    measure();
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = scrollY();
      var limit = (group ? group.offsetHeight : 120) + 40;
      if (y < limit || busy()) setHidden(false);
      else if (y > lastY + 6) setHidden(true);
      else if (y < lastY - 6) setHidden(false);
      lastY = y;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });

  /* ── Mobil-Drawer (natives <dialog>) ── */
  var drawer = doc.getElementById('lx-drawer');
  var openBtn = header.querySelector('[data-lx-menu-open]');
  function openDrawer() {
    if (!drawer || drawer.open) return;
    drawer.classList.remove('is-closing');
    if (typeof drawer.showModal === 'function') drawer.showModal(); else drawer.setAttribute('open', '');
    doc.documentElement.classList.add('lx-lock');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!drawer || !drawer.open) return;
    var done = function () {
      drawer.classList.remove('is-closing');
      if (typeof drawer.close === 'function') drawer.close(); else drawer.removeAttribute('open');
    };
    if (reduce.matches) done();
    else { drawer.classList.add('is-closing'); setTimeout(done, 190); }
  }
  if (drawer) {
    drawer.addEventListener('close', function () {
      doc.documentElement.classList.remove('lx-lock');
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus({ preventScroll: true }); }
    });
    drawer.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(); });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer(); /* Klick auf Backdrop */
      if (e.target.closest('[data-lx-menu-close]')) closeDrawer();
    });
    /* nur ein Akkordeon offen */
    drawer.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d.tagName === 'DETAILS' && d.open) drawer.querySelectorAll('details.lx-dnav__acc[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
    desk.addEventListener('change', function (m) { if (m.matches) closeDrawer(); });
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);

  /* ── Desktop-Menü: Hover (mit Verzögerung), Klick auf Pfeil, Esc, Klick außerhalb ── */
  var items = header.querySelectorAll('.lx-nav__item--sub');
  function setOpen(li, open) {
    li.classList.toggle('is-open', open);
    var b = li.querySelector('.lx-nav__toggle');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) { items.forEach(function (li) { if (li !== except) setOpen(li, false); }); }
  items.forEach(function (li) {
    var t;
    li.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; clearTimeout(t); t = setTimeout(function () { closeAll(li); setOpen(li, true); }, 80); });
    li.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'mouse') return; clearTimeout(t); t = setTimeout(function () { setOpen(li, false); }, 200); });
    var b = li.querySelector('.lx-nav__toggle');
    if (b) b.addEventListener('click', function () { var o = !li.classList.contains('is-open'); closeAll(li); setOpen(li, o); });
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) setOpen(li, false); });
    li.addEventListener('keydown', function (e) { if (e.key === 'Escape' && li.classList.contains('is-open')) { setOpen(li, false); if (b) b.focus(); } });
  });
  doc.addEventListener('pointerdown', function (e) { if (!e.target.closest('.lx-nav__item--sub')) closeAll(); });

  /* ── Suche mit Vorschlägen (/search/suggest.json) ── */
  var form = header.querySelector('[data-lx-search]');
  if (form) {
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('.lx-suggest');
    var timer, ctrl, active = -1;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var money = function (v) { var n = Number(v); if (!isFinite(n)) return ''; try { return n.toLocaleString('de-DE', { style: 'currency', currency: cur }); } catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; } };
    var img = function (src) { if (!src) return '<span class="lx-suggest__noimg" aria-hidden="true"></span>'; var u = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96'; return '<img src="' + esc(u) + '" alt="" width="48" height="48" loading="lazy">'; };
    var options = function () { return box.querySelectorAll('a'); };
    function show(open) {
      box.hidden = !open;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) { active = -1; input.removeAttribute('aria-activedescendant'); }
    }
    function render(q, r) {
      var res = (r && r.resources && r.resources.results) || {};
      var p = res.products || [], c = res.collections || [], s = res.queries || [];
      var h = '';
      if (s.length) {
        h += '<div class="lx-suggest__q">' + s.slice(0, 4).map(function (x, i) { return '<a id="lx-sg-q' + i + '" role="option" href="' + esc(x.url) + '">' + esc(x.text) + '</a>'; }).join('') + '</div>';
      }
      if (c.length) {
        h += '<p class="lx-suggest__h">Kategorien</p><ul class="lx-suggest__list">' + c.slice(0, 3).map(function (x, i) {
          return '<li class="lx-suggest__item"><a id="lx-sg-c' + i + '" role="option" href="' + esc(x.url) + '">' + img(x.featured_image && x.featured_image.url) + '<span>' + esc(x.title) + '</span><span></span></a></li>';
        }).join('') + '</ul>';
      }
      if (p.length) {
        h += '<p class="lx-suggest__h">Produkte</p><ul class="lx-suggest__list">' + p.slice(0, 6).map(function (x, i) {
          var src = x.featured_image && x.featured_image.url ? x.featured_image.url : x.image;
          return '<li class="lx-suggest__item"><a id="lx-sg-p' + i + '" role="option" href="' + esc(x.url) + '">' + img(src) + '<span>' + esc(x.title) + '</span><span class="lx-suggest__price">' + money(x.price) + '</span></a></li>';
        }).join('') + '</ul>';
      }
      if (!h) h = '<p class="lx-suggest__empty">Keine Treffer für „' + esc(q) + '“. Ruf uns gern an, wir helfen beim Suchen.</p>';
      h += '<a class="lx-suggest__all" role="option" id="lx-sg-all" href="' + esc(base + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last') + '">Alle Ergebnisse für „' + esc(q) + '“</a>';
      box.innerHTML = h;
      active = -1;
      show(true);
    }
    function fetchSuggest() {
      var q = input.value.trim();
      if (q.length < 2) { show(false); return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = base + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && input.value.trim() === q) render(q, j); })
        .catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(fetchSuggest, 180); });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) show(true); });
    input.addEventListener('keydown', function (e) {
      var o = options();
      if (e.key === 'Escape') { show(false); return; }
      if (box.hidden || !o.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (active > -1 && o[active]) o[active].removeAttribute('aria-selected');
        active = e.key === 'ArrowDown' ? (active + 1) % o.length : (active <= 0 ? o.length - 1 : active - 1);
        o[active].setAttribute('aria-selected', 'true');
        o[active].scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', o[active].id);
      } else if (e.key === 'Enter' && active > -1 && o[active]) {
        e.preventDefault();
        window.location.href = o[active].href;
      }
    });
    doc.addEventListener('pointerdown', function (e) { if (!form.contains(e.target)) show(false); });
    form.addEventListener('focusout', function (e) { if (!form.contains(e.relatedTarget)) setTimeout(function () { if (!form.contains(doc.activeElement)) show(false); }, 120); });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
  }

  /* ── Ankündigung: mobil rotierend (nicht bei reduzierter Bewegung) ── */
  if (ann) {
    var slides = ann.querySelectorAll('.lx-ann__item'), i = 0, paused = false;
    ann.addEventListener('pointerenter', function () { paused = true; });
    ann.addEventListener('pointerleave', function () { paused = false; });
    ann.addEventListener('focusin', function () { paused = true; });
    ann.addEventListener('focusout', function () { paused = false; });
    if (slides.length > 1) setInterval(function () {
      if (paused || reduce.matches || desk.matches || doc.hidden) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 5000);
  }
})();
